import clsx from 'clsx'
import { useState } from 'react'
import dynamic from 'next/dynamic'
import { eventMapping, eventData as strapiEventData } from '../strapi.tracking'
import { ONE_LINK_DOMAIN } from '../../utils/constants'
import Link from '@/components/Common/Link'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import { GA4Event } from '@/root/utils/common/web/gtm-events/types'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import Cookies from 'js-cookie'
import { getHostDomain } from '@/root/helpers'
import { BETA_INDSTOCKS_HOST, INDSTOCKS_HOST } from '@/root/constants/common'

const LoginWidgetV2 = dynamic(
  () => import('@/components/Common/LoginWidget/LoginWidgetV2'),
  { ssr: false },
)

type TProps = {
  id?: 'cta-by-type'
  type: 'primary' | 'link' | 'bordered' | 'api'
  children: string
  url: string
  addClassNames?: string
  onClickHandler?: () => void
  eventData?: GA4Event
}

export function Strapi4CTAByType(props: TProps) {
  const {
    children,
    type,
    url,
    id,
    addClassNames = '',
    onClickHandler,
    eventData = eventMapping[strapiEventData.strapiWidgetCtaClick],
  } = props
  const pushEvent = useAnalyticsEvent()
  const [openLoginModal, setOpenLoginModal] = useState(false)
  const host = getHostDomain()

  const isStocksFunnel = host === INDSTOCKS_HOST || host === BETA_INDSTOCKS_HOST

  const handleClick = () => {
    pushEvent({
      gtm4Payload: {
        eventData,
      },
    })
    onClickHandler?.()
  }

  // NOTE: Add ! before the classname while using "addClassNames" prop
  // to override the default styles of the component while using it.
  let className = `block lg:text-lg py-3 md:px-[40px] w-fit px-5 cursor-pointer ${addClassNames}`

  if (type === 'primary') {
    className = clsx(
      className,
      'text-white rounded-full bg-brand-green-dark hover:scale-98 hover:bg-[#288A3F] text-center transition-colors',
    )
  }

  if (type === 'link') {
    className = clsx(
      className,
      'text-brand-blue-azureRadiance flex items-center gap-2 rounded-full',
    )
  }
  if (type === 'bordered') {
    className = clsx(
      className,
      'text-brand-blue-azureRadiance flex items-center gap-2 rounded-full border border-brand-blue-azureRadiance',
    )
  }

  if (type === 'primary') {
    if (url.includes(ONE_LINK_DOMAIN)) {
      return (
        <>
          {typeof window !== 'undefined' && window.innerWidth > 768 && (
            <LoginWidgetV2
              openModal={openLoginModal}
              onClose={() => setOpenLoginModal(false)}
              isStocksFunnel={isStocksFunnel}
            />
          )}
          <button
            className={className}
            id={`strapi-4-component-${id}`}
            onClick={() => {
              handleClick()
              const token = Cookies.get('token')
              if (window.innerWidth > 768 && !token) {
                setOpenLoginModal(true)
              } else {
                window.location.href = url
              }
            }}
          >
            {children}
          </button>
        </>
      )
    }

    return (
      <Link
        href={url}
        className={className}
        id={`strapi-4-component-${id}`}
        onClick={handleClick}
      >
        {children}
      </Link>
    )
  }

  return (
    <Link href={url} className={className} onClick={handleClick}>
      <span>{children}</span>
      {type === 'link' && (
        <div className="flex-shrink-0">
          <StencilCDNImage
            src="https://indcdn.indmoney.com/cdn/images/fe/arrow-narrow-up-right.png"
            width={16}
            height={16}
            className="rotate-45"
            alt="check more arrow"
          />
        </div>
      )}
    </Link>
  )
}
